import * as React from 'react';

import { Box } from '@leagueplatform/genesis-core';
import { useScrollTopOnLocationChange } from '@leagueplatform/web-common';
import { APP_NAV_DEFAULT_HEIGHT } from '@highmark-web/highmark-common';
import { AppNavBarComponent } from './nav.component';
import { BCBSWyFooter } from './footer/bcbswy-footer.component';

type BaseStaticPageProps = {
  isNavEnabled?: boolean;
  isShowFooter?: boolean;
};

export const BaseStaticPage: React.FC<BaseStaticPageProps> = ({
  children,
  isNavEnabled = false,
  isShowFooter = true,
}) => {
  useScrollTopOnLocationChange();

  return (
    <>
      {isNavEnabled && <AppNavBarComponent />}
      <Box
        as="main"
        css={{
          position: 'relative',
          flex: '1',
          overflowX: 'hidden',
          // This is so any page will take up the whole screen regardless of content
          minHeight: `calc(100vh - ${APP_NAV_DEFAULT_HEIGHT}px)`,
        }}
      >
        {children}
      </Box>
      {isShowFooter && <BCBSWyFooter />}
    </>
  );
};
